module.exports = __webpack_public_path__ + "img/29.1.8ba416dc.jpg";